import { httpRequest } from '@/shared/lib/http'
import { config } from '@/config/env'
import type { OrigenDeCandidato } from '@/features/rh/lib/origenDelCandidato'

export interface ColaboradorDelDirectorio {
  id: number
  fullName: string
  areaName: string | null
  puestoName: string | null
}

export const origenesDeCandidato = {
  /**
   * Los que ve el candidato en el formulario publico.
   *
   * Va con `fetch` directo y no con `httpRequest` porque esta pantalla corre
   * sin sesion: es el mismo camino que ya usa `candidateService` para traer la
   * vacante por su token publico.
   */
  async publicos(): Promise<OrigenDeCandidato[]> {
    const respuesta = await fetch(
      `${config.apiBaseUrl}/catalogos/candidate-sources/public`,
    )
    if (!respuesta.ok) {
      throw new Error('No se pudieron cargar los origenes')
    }
    return respuesta.json()
  },

  /** Todos los activos: es lo que ve RH al dar de alta a mano. */
  async todos(): Promise<OrigenDeCandidato[]> {
    return (
      (await httpRequest<OrigenDeCandidato[]>('/catalogos/candidate-sources')) ??
      []
    )
  },

  /** Directorio para elegir a quien recomendo. */
  async colaboradores(): Promise<ColaboradorDelDirectorio[]> {
    return (
      (await httpRequest<ColaboradorDelDirectorio[]>('/employees/select')) ?? []
    )
  },

  /** `employeeId` en null deshace la vinculacion. */
  async vincularRecomendacion(candidateId: string, employeeId: number | null) {
    return httpRequest(`/candidates/profile/${candidateId}/referral`, {
      method: 'PATCH',
      body: JSON.stringify({ employeeId }),
    })
  },
}
